
export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <a href="/" className="text-2xl font-bold text-green-600" style={{ fontFamily: '"Pacifico", serif' }}>
                logo
              </a>
            </div>
            <nav className="hidden md:flex space-x-8">
              <a href="/" className="text-gray-700 hover:text-green-600 transition-colors cursor-pointer">ホーム</a>
              <a href="/services" className="text-gray-700 hover:text-green-600 transition-colors cursor-pointer">サービス</a>
              <a href="/beast-blog" className="text-gray-700 hover:text-green-600 transition-colors cursor-pointer">ブログ</a>
              <a href="/contact" className="text-gray-700 hover:text-green-600 transition-colors cursor-pointer">お問い合わせ</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">プライバシーポリシー</h1>
            <p className="text-gray-600">最終更新日：2025年11月9日</p>
          </div>

          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. 基本方針</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                メディハナ薬局（以下「当薬局」）は、お客様の個人情報の保護を重要な責務と考え、個人情報の保護に関する法律（個人情報保護法）および関連法令を遵守し、お客様の個人情報を適切に取り扱います。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. 個人情報の定義</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                本プライバシーポリシーにおいて「個人情報」とは、個人情報保護法第2条第1項に定義される個人情報、すなわち生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含む）を指します。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. 収集する個人情報</h2>
              <p className="text-gray-700 leading-relaxed mb-4">当薬局では、以下の個人情報を収集する場合があります：</p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
                <li>氏名、住所、電話番号、メールアドレス</li>
                <li>生年月日、性別</li>
                <li>処方箋情報、薬歴情報</li>
                <li>健康状態に関する情報</li>
                <li>お薬手帳の情報</li>
                <li>保険証の情報</li>
                <li>お問い合わせ内容</li>
                <li>Webサイトの利用状況（アクセスログ、Cookie等）</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. 個人情報の利用目的</h2>
              <p className="text-gray-700 leading-relaxed mb-4">収集した個人情報は、以下の目的で利用いたします：</p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
                <li>調剤業務および薬剤師による服薬指導</li>
                <li>薬歴管理および継続的な薬物療法の支援</li>
                <li>健康相談およびアドバイスの提供</li>
                <li>医療機関との連携および情報共有</li>
                <li>保険請求業務</li>
                <li>お客様からのお問い合わせへの対応</li>
                <li>サービス向上のための分析</li>
                <li>法令に基づく報告義務の履行</li>
                <li>緊急時の連絡</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. 個人情報の第三者提供</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                当薬局は、以下の場合を除き、お客様の同意なく個人情報を第三者に提供することはありません：
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
                <li>法令に基づく場合</li>
                <li>人の生命、身体または財産の保護のために必要がある場合</li>
                <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合</li>
                <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合</li>
                <li>医療機関との連携において、適切な医療提供のために必要な場合</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. 個人情報の管理</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                当薬局は、個人情報の正確性を保ち、これを安全に管理いたします。個人情報への不正アクセス、紛失、破壊、改ざん、漏洩などを防ぐため、必要かつ適切な安全管理措置を講じます。
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
                <li>個人情報保護管理者の設置</li>
                <li>従業員への教育・研修の実施</li>
                <li>アクセス権限の管理</li>
                <li>セキュリティシステムの導入</li>
                <li>定期的な安全管理措置の見直し</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. 個人情報の開示・訂正・削除</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                お客様は、当薬局が保有するご自身の個人情報について、開示、訂正、削除を求めることができます。これらのご請求については、本人確認を行った上で、法令に従って対応いたします。
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                ただし、薬事法等の法令により保存が義務付けられている情報については、法定保存期間中は削除できない場合があります。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Cookieの使用について</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                当薬局のWebサイトでは、サービス向上のためCookieを使用する場合があります。Cookieは、Webサイトがお客様のコンピュータに送信する小さなファイルで、お客様のブラウザに保存されます。
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                お客様はブラウザの設定によりCookieの受け取りを拒否することができますが、その場合、Webサイトの一部機能が利用できなくなる可能性があります。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Google Analyticsの使用について</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                当薬局のWebサイトでは、Webサイトの利用状況を分析するためにGoogle Analyticsを使用しています。Google Analyticsは、Cookieを使用してお客様の情報を収集しますが、この情報は匿名で収集されており、個人を特定するものではありません。
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                Google Analyticsによる情報収集を無効にしたい場合は、Google Analytics オプトアウト アドオンをご利用ください。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. 未成年者の個人情報</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                未成年者の個人情報を収集する場合は、保護者の同意を得た上で適切に取り扱います。未成年者ご本人からの個人情報に関するお問い合わせについては、保護者の方からご連絡いただくようお願いいたします。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">11. プライバシーポリシーの変更</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                当薬局は、法令の変更や事業内容の変更等に伴い、本プライバシーポリシーを変更する場合があります。変更後のプライバシーポリシーは、当薬局のWebサイトに掲載した時点から効力を生じるものとします。
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4 text-gray-800">12. お問い合わせ窓口</h2>
              <p className="text-gray-600 mb-4">
                個人情報の取り扱いに関するお問い合わせは、以下までご連絡ください：
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="font-semibold text-gray-800 mb-2">PharmaBeast 個人情報保護管理者</p>
                <p className="text-gray-600 mb-1">
                  <strong>メール：</strong>pharmabeast.k@gmail.com
                </p>
                <p className="text-gray-600">
                  <strong>受付時間：</strong>24時間
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">13. 認定個人情報保護団体</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                当薬局は、一般社団法人日本薬剤師会の個人情報保護指針に基づき、適切な個人情報保護に努めています。
              </p>
            </section>

            <div className="text-center mt-12 pt-8 border-t border-gray-200">
              <p className="text-gray-600">制定日：2025年11月1日</p>
              <p className="text-gray-600">最終改定日：2025年11月9日</p>
              <p className="text-gray-600 mt-4">PharmaBeast</p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg font-semibold mb-4">みんなの薬局～Pharmacare～</h3>
              <p className="text-gray-400 text-sm">
                地域の皆様の健康をサポートする薬局として、質の高いサービスを提供いたします。
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">サービス</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><a href="/services" className="hover:text-white transition-colors cursor-pointer">調剤サービス</a></li>
                <li><a href="/health-consultation" className="hover:text-white transition-colors cursor-pointer">健康相談</a></li>
                <li><a href="/otc" className="hover:text-white transition-colors cursor-pointer">OTC医薬品</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">情報</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><a href="/beast-blog" className="hover:text-white transition-colors cursor-pointer">ブログ</a></li>
                <li><a href="/information" className="hover:text-white transition-colors cursor-pointer">お知らせ</a></li>
                <li><a href="/privacy-policy" className="hover:text-white transition-colors cursor-pointer">プライバシーポリシー</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">お問い合わせ</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li>Email: pharmabeast.k@gmail.com</li>
                <li><a href="/contact" className="hover:text-white transition-colors cursor-pointer">お問い合わせフォーム</a></li>
                <li><a href="/privacy-policy" className="hover:text-white transition-colors cursor-pointer">プライバシーポリシー</a></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
            <p>&copy; 2024 みんなの薬局～Pharmacare～. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer">Website Builder</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
